<p-accordion
    [value]="collapsed() ? [] : '0'"
    transitionOptions="0ms cubic-bezier(0.86, 0, 0.07, 1)"
    [class]="class()"
    (onOpen)="onOpen.emit()"
    (onClose)="onClose.emit()"
    (valueChange)="valueChange($event)"
    >
    <p-accordion-panel value="0">
        <p-accordion-header>
            <ng-content select="[header]"></ng-content>
            @if (header()) {
                <div class="container">
                    <p>{{ header() | translate }}</p>

                    @let refresh = refreshButton();
                    @if (refresh) {
                        <btn-icon
                            [id]="'refresh-info-' + refresh.id"
                            [ariaLabel]="refresh.refreshButtonLabel"
                            [tooltip]="refresh.refreshButtonLabel"
                            [icon]="refresh.loading ? 'fa-solid fa-sync fa-spin' : 'fa-solid fa-sync'"
                            [severity]="'primary'"
                            [outlined]="true"
                            [rounded]="true"
                            [text]="true"
                            (onClick)="onRefresh.emit()"></btn-icon>
                    }
                </div>
            }
        </p-accordion-header>
        <p-accordion-content>
            <ng-content></ng-content>
        </p-accordion-content>
    </p-accordion-panel>
</p-accordion>
